import VimeoPlayer from "./VimeoPlayer";
import Player from "./Player";

document.addEventListener("DOMContentLoaded", function() {
  const videoPlayer = document.getElementById("corsi-player");
  const videoType = videoPlayer.getAttribute("data-source_type");
  const videoInstance = getVideoInstance(videoType);
  const player = new videoInstance();

  player.initVideoPlayer(function() {
    // this.play();
  });

  function getVideoInstance(videoType) {
    switch (videoType) {
      case "vimeo":
        return VimeoPlayer;
      default:
        return Player;
    }
  }

});